<template>
  <div
    data-test="person-card"
    @click="activate"
    class="card cardBorder"
  >
    <transition name="fade">
      <div class="flex flex-col">
        <div v-if="!loading">
          <div class="flex mb-xs">
            <div
              class="initials"
            >
              <span data-test="person-card-initials">{{ initials(name) }}</span>
            </div>
            <div class="name">
              <span data-test="person-card-name">{{ name }}</span>
            </div>
          </div>
          <div class="email">
            <span data-test="person-card-email">{{ email }}</span>
          </div>
          <div class="text-black">
            <slot name="additionalContent" />
          </div>
        </div>
        <div v-else>
          <div>
            <div data-test="person-card-placeholder-initials" class="placeholder-initials"></div>
            <div data-test="person-card-placeholder-name" class="placeholder-name"></div>
          </div>
          <div data-test="person-card-placeholder-email" class="placeholder-email"></div>
          <div data-test="person-card-placeholder-additional-content" class="placeholder-additional-content"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import initials from '../../filters/InitialsFilter';

export default {
  name: 'PersonCard',
  props: {
    name: {
      type: [String],
      required: true,
    },
    email: {
      type: [String],
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    activate() {
      this.$emit('activated');
    },
    initials,
  },
};
</script>

<style scoped>

.card {
  @apply
    relative
    p-base
    rounded-lg
    cursor-pointer
    w-full
    shadow-card
    hover:shadow-cardHover;
}

.initials {
  @apply
    flex
    items-center
    justify-center
    mr-base
    bg-darkBlueBackground
    text-white
    text-14
    rounded-60
    p-sm
    w-icon
    h-icon;
}

.name {
  @apply
    truncate
    text-24
    font-display
    leading-cardTitle;
}

.email {
    @apply
      truncate
      text-lightGray
      leading-24
      text-18
      mb-xs;
  }

.placeholder-initials {
  @apply
    inline-block
    animate-pulse
    bg-border
    mr-base
    rounded-60
    w-icon
    h-icon;
}

.placeholder-name {
  @apply
    inline-block
    animate-pulse
    bg-border
    w-70
    h-lg
    rounded;
  }

.placeholder-email {
  @apply
    animate-pulse
    bg-border
    my-sm
    rounded
    w-70
    h-base;
}

.placeholder-additional-content {
  @apply
    animate-pulse
    bg-border
    h-lg
    rounded;
}

</style>

